module.exports = __webpack_public_path__ + "static/media/fruits_11.6699cce3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_11.csv
// module id = 675
// module chunks = 0